import React, { Component } from "react";
import { labeledActiveFilters } from "../../../services/FilteringUtils";
import CommonUtil from "../../../utils/CommonUtil";
import ComponentHeader from "./ComponentHeader";

class ComponentHeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  initialState = {
    activeFilter: this.filterFromProps()
  };

  filterFromProps() {
    if (!this.props.activeFilter) {
      return labeledActiveFilters[0];
    }

    const filterFromProps = CommonUtil.getLastObjectFromArrayWithNestedProperty(
      labeledActiveFilters,
      "active.filterVal",
      this.props.activeFilter.active.filterVal
    );
    return filterFromProps;
  }

  componentDidUpdate() {
    if (this.props.activeFilter) {
      if (
        this.props.activeFilter.active.filterVal !==
        this.state.activeFilter.active.filterVal
      ) {
        this.setState({ activeFilter: this.filterFromProps() });
      }
    }
  }

  onActiveFilterChange = event => {
    this.setState({ activeFilter: event.target.value });
    this.props.onActiveFilterChange(event.target.value);
  };

  render() {
    const onActiveFilterChange = this.props.onActiveFilterChange
      ? this.onActiveFilterChange
      : undefined;

    return (
      <ComponentHeader
        {...this.props}
        activeFilter={this.state.activeFilter}
        onActiveFilterChange={onActiveFilterChange}
        messageHandler={this.props.messageHandler}
      />
    );
  }
}

export default ComponentHeaderContainer;
